import { render, staticRenderFns } from "./ItemListView.vue?vue&type=template&id=137f2c7b&scoped=true&"
import script from "./ItemListView.vue?vue&type=script&lang=js&"
export * from "./ItemListView.vue?vue&type=script&lang=js&"
import style0 from "./ItemListView.vue?vue&type=style&index=0&id=137f2c7b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137f2c7b",
  null
  
)

export default component.exports